/**
 * Shared numeric/text field coercion for the marine catalog admin forms
 * (`MarineCraftEditModal` and `AddCraftModal`). Extracted here once a second
 * consumer needed it — see Phase 2 Task 3's note that these were the
 * separable piece of that modal.
 *
 * ZERO IMPORTS BY DESIGN, same reasoning as `marineClassOptions.js`: pure,
 * easy to harness-test, and there is no reason for this module to ever need
 * one.
 */

/**
 * Blank sends `null`, never `0`. A `0` freeboard would feed the marine area
 * calculator a real-looking number, and the server rejects a literal 0 as
 * "not a positive number" anyway — this must not defeat that by coercing a
 * blank field to one.
 */
export const numOrNull = (v) => {
  const t = String(v ?? '').trim();
  if (t === '') return null;
  const n = Number(t);
  return Number.isFinite(n) && n > 0 ? n : null;
};

/** Free text (e.g. hull material) — blank still means "clear it", not "". */
export const textOrNull = (v) => {
  const t = String(v ?? '').trim();
  return t === '' ? null : t;
};
